import { all, fork } from 'redux-saga/effects';

import absencesSaga from './Absences';
import agendaSaga from './Agenda';
import alarmsSaga from './Alarms';
import appSaga from './App';
import authSagas from './Auth';
import busesSagas from './Buses';
import carriersSagas from './Carriers';
import contactsSagas from './Contacts';
import diversionSagas from './Diversion';
import driversSagas from './Drivers';
import noticeTemplatesSagas from './NoticeTemplates';
import noticesSagas from './Notices';
import profileSagas from './Profile';
import pupilsSagas from './Pupils';
import staffSagas from './Staff';
import routesSagas from './Routes';
import ecaSagas from './ECA';
import settingsSagas from './Settings';
import studentSagas from './Student';
import wsNotificationsSagas from './WSNotifications';
import sosSagas from './Sos';
import usersSagas from './Users';
import callSessionSagas from './CallSession';
import statisticsSagas from './Statistics';
import reportSagas from './Report';
import importExportData from './ImportExportData';
import devOverlaySagasImpl from './__dev__/devOverlay';

const devOverlaySagas =
  process.env.NODE_ENV === 'development' ? devOverlaySagasImpl : null;

export default function* rootSaga() {
  yield all([
    absencesSaga(),
    agendaSaga(),
    alarmsSaga(),
    appSaga(),
    authSagas(),
    busesSagas(),
    carriersSagas(),
    contactsSagas(),
    diversionSagas(),
    driversSagas(),
    noticeTemplatesSagas(),
    noticesSagas(),
    profileSagas(),
    pupilsSagas(),
    staffSagas(),
    routesSagas(),
    ecaSagas(),
    settingsSagas(),
    studentSagas(),
    wsNotificationsSagas(),
    sosSagas(),
    usersSagas(),
    callSessionSagas(),
    statisticsSagas(),
    reportSagas(),
    importExportData(),
    ...(devOverlaySagas ? [fork(devOverlaySagas)] : []),
  ]);
}
